import React, { useRef } from 'react';
import { Button } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import PatternPrintView from './PatternPrintView';
import { useReactToPrint } from 'react-to-print';

const PrintButton = ({ pattern }) => {
  const componentRef = useRef(null);

  const handlePrint = useReactToPrint({ 
    contentRef: componentRef,
    documentTitle: pattern.name,
  });

  return (
    <>
      <Button variant="outlined" startIcon={<PrintIcon />} onClick={handlePrint}>
        Print Pattern
      </Button>
      <div className="printContent" ref={componentRef}>
        <PatternPrintView pattern={pattern} />
      </div>
    </>
  );
};

export default PrintButton;
